import { styled } from "styled-components";
import { Sidebar } from "../sidebar/sidebar.component";
import { PageProps } from "./page.props";
import { colors } from "../../../theme/colors";

export const Page = ({
  children,
  noPadding = false,
}: PageProps) => {
  return (
    <Main>
      <Sidebar />
      <Content $noPadding={noPadding}>{children}</Content>
    </Main>
  );
};

const Main = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: clamp(1.6rem, 3vw, 4rem);

  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  padding: clamp(1.2rem, 2vw, 2rem);
  background-color: ${colors.lightBackground.hex};
  color: ${colors.text.hex};

  @media only screen and (max-width: 48em) {
    padding-top: 6rem;
  }
`;

const Content = styled.div<{
  $noPadding: boolean;
}>`
  flex: 1 1 32rem;
  min-width: 0;
  max-width: 100%;
  margin: ${({ $noPadding }) => ($noPadding ? "-2rem 0" : "0")};
`;
